import React from 'react'
import pluralize from 'pluralize'
import styled from 'styled-components'

import { TooltipPopover } from 'components/display/Tooltip'
import { DaysAvailabilities, TooltipConfig } from './types'
import { DiscountAvailable } from './discounts'
import CalendarKeys from './CalendarKeys'

const AvailabilityInfoInner = styled.div`
  padding: 0 21px 8px 21px;
  color: ${({ theme }) => theme?.['-ds-neutral-500']?.value};
`

const TooltipContents = styled.div`
  max-width: 220px;
`

interface AvailabilityInfoProps {
  discountsVisible: boolean
  activeDiscount?: DaysAvailabilities[string]['discount']
  minimumNights?: number
  snoozed?: boolean
  concurrentBookings?: boolean
  tooltip?: TooltipConfig
  onCloseTooltip: (tooltip: TooltipConfig) => unknown
}

const AvailabilityInfo = ({
  discountsVisible,
  activeDiscount,
  minimumNights,
  concurrentBookings,
  snoozed,
  tooltip,
  onCloseTooltip,
}: AvailabilityInfoProps) => {
  return (
    <>
      <AvailabilityInfoInner>
        {discountsVisible && <DiscountAvailable discount={activeDiscount} />}
        <CalendarKeys />
        {concurrentBookings && (
          <div>Availability needs to be confirmed by the host</div>
        )}
        {minimumNights > 1 && (
          <div>
            The minimum booking is {pluralize('night', minimumNights, true)}
          </div>
        )}
        {snoozed ? (
          <div>
            The host is currently taking a short break and isn&apos;t taking new
            bookings during this time.
          </div>
        ) : (
          <div>
            Prices might be higher on weekends, holidays and during peak season
          </div>
        )}
      </AvailabilityInfoInner>
      {tooltip && (
        <TooltipPopover
          referenceElement={tooltip.referenceElement}
          placement="top"
          zIndex={3}
          onClose={() => onCloseTooltip(tooltip)}
        >
          <TooltipContents>{tooltip.message}</TooltipContents>
        </TooltipPopover>
      )}
    </>
  )
}

export default AvailabilityInfo
